import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Avatar, Skeleton, Typography } from "antd";
import Button from "@/components/Button";
import { useUserStore } from "@/store";
import identityBg from "./images/identity-bg.png";

function DeveloperIdentityCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const developerProfile = useUserStore((s) => s.developerProfile);
  const profileStatus = useUserStore((s) => s.profileStatus);
  const profilePending =
    !developerProfile &&
    (profileStatus === "idle" || profileStatus === "loading");

  return (
    <section
      className="overflow-hidden rounded-[14px] border border-[#DCDCDC] bg-cover bg-center bg-no-repeat p-5 shadow-[2px_2px_30px_0_rgba(0,0,0,0.05)]"
      style={{ backgroundImage: `url(${identityBg})` }}
    >
      <div className="flex flex-col gap-2.5">
        <Typography.Text className="!text-base !font-medium !text-black">
          {t("workbench.roleTitle")}
        </Typography.Text>
        <div className="flex flex-wrap items-end gap-8">
          {profilePending ? (
            <div
              role="status"
              aria-label={t("common.loading")}
              className="flex items-center gap-5"
            >
              <Skeleton.Avatar active size={54} />
              <div aria-hidden className="flex flex-col gap-1">
                <Skeleton.Input
                  active
                  size="small"
                  style={{ width: 72, minWidth: 72, height: 24 }}
                />
                <Skeleton.Input
                  active
                  size="small"
                  style={{ width: 196, minWidth: 196, height: 22 }}
                />
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-5">
              <Avatar src={developerProfile?.displayAvatar} size={54} />
              <div className="flex flex-col gap-1">
                <Typography.Text className="!text-base !font-medium !text-black">
                  {developerProfile?.name ?? "—"}
                </Typography.Text>
                <Typography.Text className="!text-sm !text-black">
                  <span className="text-black/40">
                    {t("workbench.developerId")}
                  </span>
                  {developerProfile?.developerNo}
                </Typography.Text>
              </div>
            </div>
          )}
          <Button
            className="!h-8 !rounded-md !border-[#DCDCDC] !bg-white/80 !px-[18px] !text-xs !text-black backdrop-blur-[6px]"
            onClick={() => {
              navigate(`/developer`);
            }}
          >
            {t("workbench.accountSettings")}
          </Button>
        </div>
      </div>
    </section>
  );
}

export default DeveloperIdentityCard;
